import React, { useState } from 'react';
import { X } from 'lucide-react';

const CookieSettings = ({ onSave, onClose, initialPreferences }) => {
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: initialPreferences?.analytics || false,
    marketing: initialPreferences?.marketing || false
  });

  const cookieTypes = {
    necessary: {
      name: 'Cookies técnicas',
      description: 'Necesarias para el funcionamiento básico del sitio web. No se pueden desactivar.',
      required: true
    },
    analytics: {
      name: 'Cookies analíticas',
      description: 'Nos ayudan a entender cómo interactúa con nuestro sitio web mediante Google Analytics.',
      required: false
    },
    marketing: {
      name: 'Cookies de marketing',
      description: 'Utilizadas para mostrar anuncios relevantes y medir la efectividad de nuestras campañas.',
      required: false
    }
  };

  const handleToggle = (type) => {
    if (cookieTypes[type].required) return;
    
    setPreferences(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };

  const handleSave = () => {
    onSave(preferences);
  };

  const acceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: false
    };
    onSave(allAccepted);
  };

  const rejectAll = () => {
    const allRejected = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    onSave(allRejected);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900">Configuración de cookies</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <p className="text-gray-600 mb-6">
            Puede elegir qué tipos de cookies permitir. Las cookies técnicas son necesarias para el funcionamiento del sitio web.
          </p>

          <div className="space-y-6">
            {Object.entries(cookieTypes).map(([type, config]) => (
              <div key={type} className="border border-slate-300 p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-lg font-semibold text-gray-900">{config.name}</h3>
                  <div className="flex items-center">
                    {config.required ? (
                      <span className="text-sm text-gray-500 mr-3">Siempre activo</span>
                    ) : (
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={preferences[type]}
                          onChange={() => handleToggle(type)}
                          className="sr-only"
                        />
                        <div className={`w-11 h-6 rounded-full transition-colors ${
                          preferences[type] ? 'bg-primary-700' : 'bg-gray-200'
                        }`}>
                          <div className={`w-5 h-5 bg-white rounded-full shadow transform transition-transform ${
                            preferences[type] ? 'translate-x-5' : 'translate-x-0'
                          } mt-0.5 ml-0.5`}></div>
                        </div>
                      </label>
                    )}
                  </div>
                </div>
                <p className="text-sm text-gray-600">{config.description}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <button
              onClick={handleSave}
              className="flex-1 px-6 py-3 bg-[#0b1d39] text-white font-semibold hover:bg-primary-800 transition-colors"
            >
              Guardar preferencias
            </button>
            <button
              onClick={rejectAll}
              className="flex-1 px-6 py-3 border border-slate-300 text-slate-800 font-semibold hover:bg-slate-50 transition-colors"
            >
              Rechazar todas
            </button>
            <button
              onClick={acceptAll}
              className="flex-1 px-6 py-3 border border-slate-300 text-slate-800 font-semibold hover:bg-slate-50 transition-colors"
            >
              Aceptar todas
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieSettings;